import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * The shadcn-standard `cn` helper. Combines `clsx` (for conditional class
 * composition) with `tailwind-merge` (for resolving conflicting Tailwind
 * utility classes — e.g. `cn('p-2', 'p-4')` returns `'p-4'`, not the
 * concatenation).
 *
 * Used throughout shadcn-generated components and anywhere we conditionally
 * compose Tailwind classes.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
